var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"snt-input--rounded snt-input--outlined",attrs:{"value":_vm.value,"items":_vm.filteredSearchItems,"placeholder":_vm.placeholder,"menu-props":{
    'content-class': 'snt-search__menu snt-card--outlined',
    'origin': 'center center',
    'transition':'slide-y-transition',
    'nudge-top': '-4px',
    'offset-y': true,
  },"prepend-inner-icon":"mdi-magnify","background-color":"#ffffff","outlined":"","hide-details":"","hide-no-data":"","hide-selected":"","auto-select-first":"","clearable":"","cache-items":"","dense":""},on:{"update:search-input":function($event){return _vm.changeValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }